import {
  GET_WEBFORM_SUCCESS,
  GET_WEBFORM_FAILURE
} from '../../actions/api/webform';
import { GET_WEBHOOKS_FAILURE } from '../../actions/api/webhooks';
import {
  GET_WEBHOOK_SUCCESS,
  GET_WEBHOOK_FAILURE,
  POST_WEBHOOK_REQUEST,
  POST_WEBHOOK_SUCCESS,
  POST_WEBHOOK_FAILURE
} from '../../actions/api/webhook';
import {
  WEBFORM_INITIALIZE,
  WEBFORM_UPDATE_FIELDS
} from '../../actions/page/Webform';
import cloneDeep from 'lodash/cloneDeep';

export default function Webform(state = {}, action) {
  switch (action.type) {
    case WEBFORM_INITIALIZE:
      const defaults = {
        loading: true,
        webhookID: null,
        notFound: false,
        saving: false,
        successMessage: undefined,
        fields: []
      };
      return {
        ...state,
        ...defaults
      };
    case WEBFORM_UPDATE_FIELDS:
      const newFields = state.fields.slice();
      const changedIndex = newFields.findIndex(
        field => field.fieldName === action.field.fieldName
      );
      newFields[changedIndex] = action.field;
      return {
        ...state,
        fields: newFields
      };
    case GET_WEBFORM_SUCCESS:
      const webform = ((action.response.entities || {}).webhooks || {})[
        action.response.result
      ];
      return {
        ...state,
        webhookID: webform.webhookID,
        loading: false,
        fields: cloneDeep(webform.fields)
      };
    case GET_WEBFORM_FAILURE:
      return {
        ...state,
        loading: false,
        notFound: true
      };
    case GET_WEBHOOKS_FAILURE:
      return {
        ...state,
        notFound: true
      };
    case GET_WEBHOOK_SUCCESS:
      const webhook = action.response.entities.webhooks[action.response.result];
      return {
        ...state,
        loading: false,
        webhookID: webhook.webhookID,
        fields: cloneDeep(webhook.fields)
      };
    case GET_WEBHOOK_FAILURE:
      return {
        ...state,
        loading: false,
        notFound: true
      };
    case POST_WEBHOOK_REQUEST:
      return {
        ...state,
        saving: true
      };
    case POST_WEBHOOK_SUCCESS:
      return {
        ...state,
        saving: false,
        successMessage: 'Success! The form has been completed. Thanks!'
      };
    case POST_WEBHOOK_FAILURE:
      return {
        ...state,
        saving: false
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./js/reducers/page/Webform.js